// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4223) return "static/chunks/commons-00e2d1ca59e36435.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3046 ? "splide" : chunkId) + "." + {"438":"632e669a0dab75b8","1802":"461ccd883330c8e9","2918":"d8de715a18857189","3046":"0846e9ba123f92f9","3219":"ddd5051927c42d3a","4591":"cc4e189f784af80c","5450":"8b42b3daafe1c2c3","6581":"5e569114f5671952","7250":"2b7fe8681328fcba","8538":"51806211e2ef20de"}[chunkId] + ".js";
};